import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/customer-details')({
  beforeLoad: () => getTitleContextSlice('Customer Details'),
  staticData: {
    owner: CodeOwner.Frontend,
  },
});
